import classNames from "classnames";

import {autoDuration} from "@/lib/format.tsx";
import {Service, ServiceDefinition} from "@/lib/types/checks.ts";
import {responseTimeCSSClass} from "@/pages/dashboard/display/dashboardUtils.ts";

import styles from "@/pages/dashboard/display/components/CheckCard.module.scss";

export const CheckResponseTimeValue = ({
  service,
  serviceDefinition,
}: {
  service: Service;
  serviceDefinition: ServiceDefinition;
}) => (
  <>
    <div className={styles.checkCardStatName}>{serviceDefinition.performance_data_type_display}</div>
    <div
      className={classNames(
        styles.checkCardStatValue,
        responseTimeCSSClass(service.cached_response_time, Number(service.msp_response_time_sla))
      )}
    >
      {autoDuration(service.cached_response_time)}
    </div>
  </>
);
